import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "page flex-col",
  id: "eco_body"
}
const _hoisted_2 = { class: "box_1 flex-row" }
const _hoisted_3 = { class: "box_2 flex-col" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "box_5 flex-row justify-between" }
const _hoisted_6 = { class: "box_6 flex-row" }
const _hoisted_7 = { class: "image-text_1 flex-row justify-between" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "box_6 flex-row" }
const _hoisted_11 = { class: "image-text_1 flex-row justify-between" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "box_7 flex-row" }
const _hoisted_15 = { class: "image-text_2 flex-row justify-between" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "image-wrapper_1 flex-col" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "box_9 flex-col" }
const _hoisted_20 = { class: "box_11 flex-row" }
const _hoisted_21 = { class: "group_6 flex-col group6_active" }
const _hoisted_22 = { class: "group_6 flex-col group6_active" }
const _hoisted_23 = { class: "group_8 flex-col group6_active" }
const _hoisted_24 = { class: "group_10 flex-col group6_active" }

import { nextTick } from 'process';
import { reactive, ref } from 'vue';
import {useRouter} from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
nextTick(()=>{
    let dom = document.querySelector('#eco_body') as any
    dom.style.zoom = 0.75
})

const getIcon = (n: number) => {
    if (!n) n = 1
    return require(`@/assets/images/eco-friendly/icon (${n}).png`)
}
const toContentList =(typeName: String) =>{
  let param = {
    themeId: '1689842778562998273',
    typeName: typeName
  }
  router.push({
    path: '/friendly-news-list',
    query: param
  })
}
/* const style = document.body.style as any
style.zoom = 0.75 */

return (_ctx: any,_cache: any) => {
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"box_3 flex-row\" data-v-08b832ee><div class=\"text-wrapper_1 flex-col justify-between\" data-v-08b832ee><span class=\"text_1\" data-v-08b832ee>开封市城乡一体化示范区</span><span class=\"text_2\" data-v-08b832ee>工业企业污染防治学习平台</span></div></div><div class=\"box_4 flex-row\" data-v-08b832ee><div class=\"text-group_1 flex-col justify-between\" data-v-08b832ee><span class=\"text_5\" data-v-08b832ee>践行绿色环保概念</span><span class=\"text_6\" data-v-08b832ee> Lucid waters and mountains are invaluable assets </span></div></div>", 2)),
          _createElementVNode("div", _hoisted_4, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-group_2 flex-col justify-between" }, [
              _createElementVNode("span", { class: "text_7" }, "行政审批"),
              _createElementVNode("span", { class: "text_8" }, "Administrative Office")
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    class: "label_1",
                    referrerpolicy: "no-referrer",
                    src: getIcon(11)
                  }, null, 8, _hoisted_8),
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-group_3" }, "环境影响评价", -1))
                ]),
                _createElementVNode("img", {
                  class: "thumbnail_2",
                  referrerpolicy: "no-referrer",
                  src: getIcon(9)
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("img", {
                    class: "label_1",
                    referrerpolicy: "no-referrer",
                    src: getIcon(12)
                  }, null, 8, _hoisted_12),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-group_3" }, "排污许可证", -1))
                ]),
                _createElementVNode("img", {
                  class: "thumbnail_2",
                  referrerpolicy: "no-referrer",
                  src: getIcon(9)
                }, null, 8, _hoisted_13)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("img", {
                    class: "label_2",
                    referrerpolicy: "no-referrer",
                    src: getIcon(12)
                  }, null, 8, _hoisted_16),
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-group_4" }, "绩效分级", -1))
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("img", {
                    class: "image_1",
                    referrerpolicy: "no-referrer",
                    src: getIcon(3)
                  }, null, 8, _hoisted_18)
                ])
              ])
            ]),
            _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"box_8 flex-row justify-between\" data-v-08b832ee><div class=\"group_1 flex-col\" data-v-08b832ee><div class=\"group_2 flex-col\" data-v-08b832ee></div><span class=\"text_9\" data-v-08b832ee> 提升原辅材料的源头替代、废气收集与处理、厂区绿化和车间除尘、危废间现场管理、各类台账管理、加强环保设备维护等 </span><div class=\"text-wrapper_3 flex-col\" data-v-08b832ee><span class=\"text_10\" data-v-08b832ee>查看更多</span></div></div><div class=\"image_2\" referrerpolicy=\"no-referrer\" data-v-08b832ee></div></div>", 1)),
            _createElementVNode("div", _hoisted_19, [
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "box_10 flex-row" }, [
                _createElementVNode("div", { class: "text-group_5 flex-col justify-between" }, [
                  _createElementVNode("span", { class: "text_11" }, "污染防治"),
                  _createElementVNode("span", { class: "text_12" }, " Prevention And Control Work ")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_20, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "group_3 flex-col" }, null, -1)),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("a", {
                    class: "text-group_7 flex-col justify-between",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (toContentList('大气污染防治')))
                  }, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("span", { class: "text_17" }, "大气污染防治", -1),
                    _createElementVNode("span", { class: "text_18" }, "工业源、移动源污染治理", -1)
                  ]))])
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "group_5 flex-col" }, null, -1)),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("a", {
                    class: "text-group_7 flex-col justify-between",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (toContentList('水污染防治')))
                  }, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("span", { class: "text_17" }, "水污染防治", -1),
                    _createElementVNode("span", { class: "text_18" }, "关于水污染的防治与治理", -1)
                  ]))])
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "group_7 flex-col" }, null, -1)),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("a", {
                    class: "text-group_8 flex-col justify-between",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (toContentList('固废危废')))
                  }, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("span", { class: "text_20" }, "固废危废", -1),
                    _createElementVNode("span", { class: "text_21" }, "网站平台、法律法规、危废管理", -1)
                  ]))])
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "group_9 flex-col" }, null, -1)),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("a", {
                    class: "text-group_9 flex-col justify-between",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (toContentList('执法监管典型案例')))
                  }, [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("span", { class: "text_23" }, "执法监管典型案例", -1),
                    _createElementVNode("span", { class: "text_24" }, "工业源、移动源污染治理", -1)
                  ]))])
                ])
              ])
            ]),
            _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"text-group_10 flex-col justify-between\" data-v-08b832ee><span class=\"text_25\" data-v-08b832ee>意见建议</span><span class=\"text_26\" data-v-08b832ee>Recommendations Opinion</span></div><div class=\"box_14 flex-row justify-between\" data-v-08b832ee><div class=\"block_3 flex-col\" data-v-08b832ee></div><div class=\"block_4 flex-col justify-between\" data-v-08b832ee><div class=\"text-wrapper_4 flex-col\" data-v-08b832ee><input class=\"input_class\" placeholder=\"输入您企业的行业\" maxlength=\"50\" data-v-08b832ee></div><div class=\"text-wrapper_5 flex-col\" data-v-08b832ee><input class=\"input_class\" placeholder=\"输入您的手机号码\" maxlength=\"11\" data-v-08b832ee></div><div class=\"text-wrapper_6 flex-col\" data-v-08b832ee><textarea class=\"input_class\" placeholder=\"输入您的意见、建议、需要了解的内容等\" maxlength=\"300\" data-v-08b832ee></textarea></div><div class=\"text-wrapper_7 flex-col\" data-v-08b832ee><span class=\"text_30\" data-v-08b832ee>提交</span></div></div></div>", 2))
          ])
        ])
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})